import React from 'react';
import { Box, Breadcrumbs } from '@hopskipdrive/react-components';
import { uniqueId } from 'lodash';

import { RouterLink } from '../Links';

export interface BreadcrumbsNavProps {
  crumbs: Crumb[];
  onCrumbClick?: (event: React.MouseEvent, targetPath: string) => void;
}

export const BreadcrumbsNav: React.FC<BreadcrumbsNavProps> = ({ crumbs, onCrumbClick }) => {
  const getPath = (index) =>
    crumbs
      .map((crumbPath) => crumbPath?.pathname)
      .slice(0, index)
      .join('/');

  return crumbs.length ? (
    <Breadcrumbs data-testid="breadcrumbs-nav" aria-label="breadcrumb">
      {crumbs.map((crumb, index) => (
        <RouterLink
          key={uniqueId()}
          data-testid="crumb-item"
          to={getPath(index + 1)}
          onClick={(event) => onCrumbClick?.(event, getPath(index + 1))}
        >
          {crumb?.title}
        </RouterLink>
      ))}
    </Breadcrumbs>
  ) : (
    <Box minHeight="0.75rem"></Box>
  );
};

BreadcrumbsNav.defaultProps = {
  crumbs: [],
};
